import { useUserContext } from '@ilteducation/ilt-auth';
import { useAggregateContexts, useSearchContexts } from '@ilteducation/content-search';
import { useMyOrganizations } from '@ilteducation/my-account';

const useLogout = () => {
  const userContextStore = useUserContext();
  const { clearSearch } = useSearchContexts();
  const { logout: userContextLogout } = userContextStore;
  const { clearAggr } = useAggregateContexts();
  const { reset: resetMyOrganizations } = useMyOrganizations();

  return async () => {
    await userContextLogout();
    clearSearch();
    clearAggr();
    resetMyOrganizations();
  };
};

export default useLogout;
